import {City} from "../_models/city";

export class CityUtils {
  static getDefaultCity(cities: City[]): City|undefined {
    return cities.find(city => city.default);
  }
}